(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mw-tst').forEach(function (root) {
    var track = root.querySelector('.mw-tst__track');
    var bar = root.querySelector('.mw-tst__progress span');
    var buttons = root.querySelectorAll('[data-mw-tst]');
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('mw-tst--static', max <= 1);
      bar.style.transform = 'scaleX(' + Math.min(1, (track.scrollLeft + track.clientWidth) / track.scrollWidth) + ')';
      buttons[0].disabled = track.scrollLeft <= 1;
      buttons[1].disabled = track.scrollLeft >= max - 1;
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var card = track.querySelector('.mw-tst__card');
        var step = card ? card.offsetWidth + parseFloat(getComputedStyle(track).columnGap) : track.clientWidth;
        track.scrollBy({ left: step * Number(button.dataset.mwTst), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
